import * as React from "react";
import { useRifm } from "rifm";
import { formatSimCode } from "@nju/utils";
import { Input, InputProps, InputStyleProps } from "../Input";

const accept = /\d{0,19}/g;

interface IProps extends InputStyleProps {
  onValueChange?: (value: string) => void;
  defaultValue?: string;
  suffix?: InputProps["suffix"];
  isDisabled?: boolean;
  label: string;
}

const numberFormat = (value: string) => {
  return formatSimCode(value, accept, " ");
};

export function FullSimCardNumberField({
  state,
  onValueChange,
  suffix,
  label,
  defaultValue = "",
  isDisabled,
}: IProps) {
  const [value, setValue] = React.useState(defaultValue);

  const rifm = useRifm({
    accept,
    value,
    onChange: setValue,
    format: numberFormat,
  });

  React.useEffect(() => {
    if (onValueChange) {
      onValueChange(value);
    }
  }, [value, onValueChange]);

  return (
    <Input
      isDisabled={isDisabled}
      label={label}
      name="simCode"
      onChange={rifm.onChange}
      state={state}
      suffix={suffix}
      value={rifm.value}
    />
  );
}
